export default __webpack_public_path__ + "static/media/file-searching-loop.a5921551.gif";